import { DesignProp, GeneralProp } from "../PropCategories";

export const objectPosition = {
  prop: "style-attribute",
  name: "Object Position",
  nameI18n: "builder_ui.prop_type.styles.object_position",
  category: [DesignProp, GeneralProp],
  type: "select",
  defaultValue: "center",
  options: [
    {
      label: "Center",
      labelI18n: "builder_ui.prop_type.styles.object_position_types.center",
      value: "center",
    },
    {
      label: "Top",
      labelI18n: "builder_ui.prop_type.styles.object_position_types.top",
      value: "top",
    },
    {
      label: "Bottom",
      labelI18n: "builder_ui.prop_type.styles.object_position_types.bottom",
      value: "bottom",
    },
    {
      label: "Left",
      labelI18n: "builder_ui.prop_type.styles.object_position_types.left",
      value: "left",
    },
    {
      label: "Right",
      labelI18n: "builder_ui.prop_type.styles.object_position_types.right",
      value: "right",
    },
  ],
} as const;
